import { Separator } from '@components/atoms/Separator';
import { Typography } from '@components/atoms/Typography';
import { showAmount } from '@utils/currency';

import { TSubtotalListProps } from './types';

export const SubtotalList = ({ summary, orderCurrency }: TSubtotalListProps) => {
  const { fees, shipping } = summary;
  const showShipping = shipping !== undefined;
  const showFees = fees !== undefined && fees.value > 0;
  const isFreeShipping = shipping?.value === 0;

  return (
    <>
      {(showFees || showShipping) && <Separator />}
      <div className="space-y-3">
        {showShipping && (
          <div className="flex justify-between text-foreground">
            <Typography text={shipping?.label} className="text-[16px]" />
            {isFreeShipping ? (
              <Typography
                textKey="Checkout.free"
                className="text-[16px] text-[#4d8e25]"
                weight={500}
              />
            ) : (
              <Typography
                text={showAmount({
                  value: shipping?.value ?? 0,
                  currency: orderCurrency,
                })}
                className="text-[16px]"
                weight={500}
              />
            )}
          </div>
        )}

        {showFees && (
          <div className="flex justify-between text-foreground">
            <Typography text={fees.label} className="text-[16px]" />

            <Typography
              text={showAmount({
                value: fees?.value ?? 0,
                currency: orderCurrency,
              })}
              className="text-[16px]"
              weight={500}
            />
          </div>
        )}
      </div>
      {(showShipping || showFees) && <Separator />}
    </>
  );
};
